import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function FilterPanel({ title = 'Filters', children, actions, sx = {} }) {
    return (
        <Box
            component="section"
            sx={{
                p: { xs: 2, sm: 2.5 },
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
                boxShadow: '0 1px 3px rgba(15, 23, 42, 0.04)',
                ...sx,
            }}
        >
            {title && (
                <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 600, mb: 1.5 }}>
                    {title}
                </Typography>
            )}
            <Box>{children}</Box>
            {actions && <Box sx={{ mt: 2 }}>{actions}</Box>}
        </Box>
    );
}
